var _ = require('lodash');

module.exports = function () {
  Number.prototype.formatMoney = function (c, d, t) {
    var n = this,
      c = isNaN((c = Math.abs(c))) ? 2 : c,
      d = d == undefined ? '.' : d,
      t = t == undefined ? ',' : t,
      s = n < 0 ? '-' : '',
      i = `${parseInt((n = Math.abs(+n || 0).toFixed(c)))}`,
      j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      s +
      (j ? i.substr(0, j) + t : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
      (c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : '')
    );
  };
};

var minusSign = '-',
  orderSign = ','; // thousands

function format(stringValue) {
  // adds ','' to thousands
  var p = stringValue.indexOf('.');
  return stringValue.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, ($0, i) =>
    p < 0 || i < p ? $0 + orderSign : $0,
  );
}

var getFloat = function (value) {
  if (!_.isNumber(value)) {
    return NaN;
  }
  return parseInt(value) / 100;
};

var getInt = function (value) {
  if (!_.isNumber(value)) {
    return NaN;
  }
  return Math.floor(Math.round(parseFloat(value) * 10000) / 100);
};

var getMoneyFromFloat = function (value) {
  if (!_.isNumber(value) || _.isNaN(value)) {
    return '$0.00';
  } // maybe ''

  var result = format(Math.abs(value).toFixed(2));

  if (value < 0) {
    return `${minusSign}$${result}`;
  }
  return `$${result}`;
};

var getMoneyFromInt = function (value) {
  return getMoneyFromFloat(getFloat(value));
};

module.exports.getFloat = getFloat;
module.exports.getInt = getInt;
module.exports.getMoneyFromInt = getMoneyFromInt;
module.exports.getMoneyFromFloat = getMoneyFromFloat;
